import { Constructable, Container } from "typedi";

export function InjectService(service?: string | Constructable<unknown>) {
  return (target, propertyKey) => {
    const serviceOrClass = service || Reflect.getMetadata("design:type", target, propertyKey);
    Object.defineProperty(target, propertyKey, {
      get() {
        return Container.get(serviceOrClass);
      },
    });
  };
}
